import request from "@/utils/request";

export function getCourseDetail(data) {
  return request({
    url: "product/course/detail",
    params: data,
  });
}

export function getQuestionDetail(data) {
  return request({
    url: "product/questionset/detail",
    params: data,
  });
}

export function getIdentityDetail(data) {
  return request({
    url: "product/identity/detail",
    params: data,
  });
}

/**
 * 获取课程系列课
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getCourseCollectionDetailApi(data) {
  return request({
    url: "product/course/detail-series",
    params: data,
  });
}

/**
 * 获取合集列表
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getCompilation(data) {
  return request({
    url: "product/questionset/list-tag",
    params: data,
  });
}

/**
 * 获取合集列表
 * {String} no 课程编号
 * @return {AxiosPromise}
 */
export function getCollectionList(data) {
  return request({
    url: "product/questionset/collection-list",
    params: data,
  });
}
